import script from "./Marketing.vue?vue&type=script&setup=true&lang=js"
export * from "./Marketing.vue?vue&type=script&setup=true&lang=js"

import "./Marketing.vue?vue&type=style&index=0&id=f32ae662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f32ae662"]])

export default __exports__